import { c as _c } from "react/compiler-runtime";
import { CONTENT_CLASSNAME, LINK_CLASSNAME } from '@/app/lcv/components/sections/news-activities/details/content-rows/constants';
import { DetailsContentRow } from '@/app/lcv/components/sections/news-activities/details/details-content-row';
import { cn } from '@/app/utils/cn';
import { buildHtmlMarkup } from '@/app/utils/html/html';
import type { ComponentNewsHighlighted } from '@/types/tis-cms/types';
export const HighlightedContent = t0 => {
  const $ = _c(12);
  const {
    data
  } = t0;
  let t1;
  if ($[0] !== data.title) {
    t1 = buildHtmlMarkup(data.title);
    $[0] = data.title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <h2 className="text-sub-h2 font-noto-bold" dangerouslySetInnerHTML={t1} />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("text-body-1 text-gray-700", CONTENT_CLASSNAME, LINK_CLASSNAME);
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== data.textContent) {
    t4 = buildHtmlMarkup(data.textContent);
    $[5] = data.textContent;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <div className={t3} dangerouslySetInnerHTML={t4} />;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t2 || $[10] !== t5) {
    t6 = <DetailsContentRow contentClassName="space-y-4 md:space-y-6 md:px-12"><div className="rounded-base-md bg-silver-50 space-y-2 p-4">{t2}{t5}</div></DetailsContentRow>;
    $[9] = t2;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};